import { post, get, del, put, delBulk} from "../http";

export const dashboardInfoUrl = () => get("/home/dashboard/info");
export const dashboardSmsInfoUrl = () => get("/sms/report/balance/info");
export const dashboardClassWiseInfoUrl = () => get("/student/report/class-wise/summary");
export const dashboardInstiuteInfoUrl = () => get("/institute/view");

